import { apiModerationResultDetailRetrieve } from '@rover/rsdk/src/apiClient/latest/api-moderation-result-detail-retrieve';
import type { ModerationResult } from '@rover/rsdk/src/apiClient/latest/model/moderationResult';
import { HttpError } from '@rover/rsdk/src/errors';

export const MODERATION_POLL_INTERVAL_MS = 500;
/**
 * With the interval, the wait before the sitter sees "We couldn't check your photo" (10s).
 * DEV-157113 will size it from Cinder's measured latency.
 */
export const MODERATION_POLL_ATTEMPTS = 20;

const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

// The API reads the result from a replica, which can lag behind the row the upload just wrote.
const retrieveUnlessNotFound = async (opk: string): Promise<ModerationResult | null> => {
  try {
    return await apiModerationResultDetailRetrieve(opk);
  } catch (e) {
    if (e instanceof HttpError && e.statusCode === 404) return null;
    throw e;
  }
};

/** Polls until the result leaves `pending`; `null` when the budget runs out first. */
export const pollModerationResult = async (opk: string): Promise<ModerationResult | null> => {
  for (let attempt = 1; attempt <= MODERATION_POLL_ATTEMPTS; attempt += 1) {
    // eslint-disable-next-line no-await-in-loop
    const result = await retrieveUnlessNotFound(opk);
    if (result && result.status !== 'pending') return result;

    if (attempt < MODERATION_POLL_ATTEMPTS) {
      // eslint-disable-next-line no-await-in-loop
      await wait(MODERATION_POLL_INTERVAL_MS);
    }
  }

  return null;
};
